var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "sidebar" }, [
    _c(
      "div",
      {
        staticClass: "sidebar__bar",
        attrs: { id: "menuBar" },
        on: { click: _vm.toggleSidebar }
      },
      [
        _c("i", {
          staticClass: "fa",
          class: _vm.showSidebar ? "fa-close" : " fa-bars"
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "sidebar__list-wrapper",
        class: { "sidebar__list-wrapper--show": _vm.showSidebar },
        attrs: { id: "menuWrapper" }
      },
      [_vm._t("content")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-449b787a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-449b787a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/layout/menu/MainMenu.vue
// module id = 345
// module chunks = 0